import { LoginTypes } from "./actionTypes";

const initialState = {
  data: {
    roles: [],
    office_ids: [],
    team_id: null,
    user_id: null
  },
  error: "",
  loading: false,
};

const login = (state = initialState, action: any) => {

  switch (action.type) {
    case LoginTypes.LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LoginTypes.LOGIN_SUCCESS:
      state = {
        ...state,
        data: {
          roles: Array.isArray(action.payload?.roles) ? action.payload.roles : [],
          office_ids: Array.isArray(action.payload?.office_ids) ? action.payload.office_ids : [],
          team_id: action.payload?.team_id ?? null,
          user_id: action.payload?.user_id ?? null,
        },
        loading: false,
      };
      break;
    case LoginTypes.LOGOUT_USER:
      state = { ...state, loading: true };
      break;
    case LoginTypes.LOGOUT_USER_SUCCESS:
      state = { ...initialState, loading: false };
      break;
    case LoginTypes.API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
